export default __webpack_public_path__ + "static/media/character.9810fbb5.png";